const autoNgTemplateLoaderTemplate1 = require('./containerCapabilities.html');

angular.module('shbdeployer.docker').component('containerCapabilities', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    capabilities: '=',
  },
});
